import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {
  public mdevice_id:string="";
  public muser_obj: Object = {};
  public muser_logged_in: boolean = false;
  public agrizy_token:string="";
  public agrizy_session_key:string="";
  public muser_id:string="";
  public muser_email: string = "";
  public muser_fname: string = "";
  public muser_lname: string = "";
  public mcomp_name: string = "";
  public mcomp_dname: string = "";
  public mcomp_key:string="";

  public mdev_mode="mobile";
  public muser_type_id: number = 0;
  public mflag_admin:boolean=false;
  public mflag_agrizy_employee:boolean=false;
  public mflag_kyc_veri:boolean=false;
  public mflag_impersonate:boolean=false;
  public mimpersonate_user_id: string;
  public mimpersonate_log_id: string;
  public mcust_id: string;
  public muser_mobile_isd: string;
  public muser_mobile_no: string;
  public mses_key: string;
  public mflag_crea_cust: boolean =false;

  public mflag_ipm_access_rm: boolean = false;
  public mflag_ipm_access_admin: boolean = false;
  public mflag_ipm_and_trading_access_rm: boolean = false;
  public mflag_tcb_access_trade_direct: boolean = false;
  public mflag_tcb_access_trade_fintech: boolean = false;
  public mflag_tcb_category_head_approval: boolean = false;

  public agrizy_trans_cust_id = "54ff6dbe-0cf2-40c5-96e2-c481c6b8fa85"
  muser: any;

  public creating_supply=false; // Temp Variable to handle time-out

  // Documents Type ID for customers KYC
  public cust_doc_type_id_pan= "ea25ed34-d140-45b3-b933-ab5111566763"
  public cust_doc_type_id_aadhaar= "c71acd29-650b-4648-bedd-d5ac1964a358"
  public cust_doc_type_id_gstCertificate= "9c06326c-0406-4798-9313-85a2389f473c"
  public cust_doc_type_id_cancelledCheque= "344f544b-277f-4e87-b590-2bf4b759cf7e"
  public cust_doc_type_id_other= "c33cee73-4f22-48cb-8f64-009ae572f004"
  public cust_doc_type_id_msme = "abe9652c-0be4-11ee-bf5f-42010a400006"

  // Documents Type ID for Transactions
  public invoice_doc_type_id = "d303aabd-ac18-4201-ae6b-a2a232fadf5a";
  public ewayBill_doc_type_id = "0a1cfa4e-0614-4e1e-a1aa-6f86474e3d7f";
  public grn_doc_type_id = "649a26e9-47e8-46ea-be4c-3b3dd6bc6f4e";
  public lr_doc_type_id = "fe128152-d19f-431c-9fbf-3f7871cfb1d1";
  public permits_doc_type_id = "cc5246e3-3067-4939-8b48-a72dbad84894";
  public others_doc_type_id = "84bf9fb9-2ab7-11ee-9426-42010aa00002";
  public frs_doc_type_id = "7b6efcdf-6cdd-11ee-ba1e-42010aa00002";
  public supplier_inv_doc_type_id = "be411fac-db6c-11ee-a413-026a5402369e";

  // Documents Type ID for Buyer PO
  public buyer_po_doc_type_id = "2b9647d6-6ca8-11ee-9c34-42010a400009";

  // Documents Type ID for Payments
  public payments_doc_type_id = "0f8c3d53-6cad-11ee-ba1e-42010aa00002";

  // Documents Type ID for Transport Declaration
  public trans_decl_doc_type_id = "e32f9608-6ca5-11ee-ba1e-42010aa00002";

  // Documents Type ID for Post Supply
  public supply_doc_type_id = "91cd80dc-6cb3-11ee-ba1e-42010aa00002";

  // Documents Type ID for Enquiries bid
  public enquiries_doc_type_id = "2329afcd-6cb4-11ee-ba1e-42010aa00002";

  // Documents Type ID for TCB
  public tcb_doc_type_id = "226e28aa-7e4b-11ee-b123-42010aa00002";

  // Documents Type ID for Bulk Import
  public material_bulk_import_type_id = "df84b670-203f-11f0-b51f-028413600caa";

  // Documents Type ID for PO Declaration
  public po_declaration_doc_type_id = "3136062f-1c0b-411f-9a10-061de26dbdf3";

  // Documents Type ID for SOP
  public sop_pur_doc_type_id = "0f2e5954-6400-4e9f-8107-216f7be5c1a2";
  public sop_prod_doc_type_id = "9739d099-88b3-4628-8e28-6bdb9bc4313b";
  public sop_grn_doc_type_id = "b1a2c008-5f35-4307-85fc-1729818e2a07";

  // Buyer TCB
  public mbuyer_tcb: any = {};
  public mbuyer_tcb_materials: any = [];
  public mbuyer_tcb_pmt_terms: any = {};

  // Supplier TCB
  public msupplier_tcb: any = [];
  public msupplier_tcb_materials: any = [];
  public msupplier_tcb_pmt_terms: any = {};

  public magrizy_fin_tech: boolean = false;
  public mflag_fintech_access_rm: boolean = false;

  public mflag_early_pmt_release: boolean = false;
  public mflag_supplier_early_pmt_rm_auth: boolean = false;
  public mflag_early_pmt_restriction: boolean = false;

  public finTech_token: string = '';
  public finTech_session_key: string = '';
  public mft_user_id: string = '';

  public mft_company_details: any = {};
  public mft_buyer_list: any = [];

  // FinTech Company Status
  public mft_comp_draft: any = 100;
  public mft_comp_credit_review: any = 350;
  public mft_comp_sent_review: any = 400;
  public mft_comp_resubmit_credit_review: any = 401;
  public mft_comp_credit_approved: any = 800;
  public mft_comp_credit_rejected: any = 900;
  public mft_comp_ops_approved: any = 1500;
  public mft_comp_ops_rejected: any = 1600;
  public mft_comp_in_lender_process: any = 2700;
  public mft_comp_ps_shared_to_rm: any = 3600;
  public mft_comp_ps_doc_shared_to_rm: any = 5500;
  public mft_comp_in_process: any = 2890;
  public mft_comp_live: any = 2899;
  public mft_comp_onboarded: any = 2900;
  // limit enhancement (credit re-evaluation) requested for an existing client;
  // approval puts the company back to mft_comp_live
  public mft_comp_limit_enhancement_requested: any = 2760;
  public mft_comp_rejected: any = 2910;
  public mft_comp_discarded: any = 3000;

  // FinTech Lender Status
  public mft_lender_approved: any = 5800;
  public mft_lender_discarded: any = 5900;
  public mft_lender_rejected: any = 6000;

  // FinTech Case Status
  public mft_case_draft: any = 6100;
  public mft_case_pending_verification: any = 6100;
  public mft_case_revision: any = 6500;
  public mft_case_ops_rejected: any = 6600;
  public mft_case_pending_with_fops: any = 6800;
  public mft_case_send_to_verification: any = 7000;
  public mft_case_revision_in_progress: any = 7200;
  public mft_case_ft_rejected: any = 7500;
  public mft_case_sent_to_lender: any = 7900;
  public mft_case_lender_rejected: any = 8200;
  public mft_case_fund_disbursed: any = 8400;
  public mft_case_discarded: any = 8800;
  public mft_case_repaid: any = 9000;

  public mpur_inv_date_from: string = "2025-06-25";

  public mflag_rm_delegate: boolean = false;
  public mdelegate_rm_id: string = null;
  public mflag_rpc_hsn_replacement: boolean = false;
  public mflag_cr_eval_check: boolean = false;

  // Gates the Overseas Sales home menu card. Populated from the stored user_obj
  // in AZUtils.setSessionData(); defaults to false until the backend sends it.
  public mflag_overseas_sale: boolean = false;
}